import React from 'react';
import { useParams } from 'react-router-dom';
import { getURLParams } from '~shared/helpers/helper';
import { CommsVerificationStatus } from './CommsVerificationStatus';

type RouteParams = {
  commsChannel: string;
  verificationStatus: string;
};

export const UnauthCommsVerificationStatus = () => {
  const { commsChannel = '', verificationStatus } = useParams<RouteParams>();
  const { token } = getURLParams();

  return (
    <CommsVerificationStatus
      isVerified={verificationStatus === 'success'}
      loading={false}
      commsChannel={commsChannel}
      authorized={false}
      token={token}
    />
  );
};
